export const getEmailFrequencies = (state) =>
  state.settings.data.emailsFrequencies || [];
